import React from "react";
import { useLanguage } from "../context/LanguageContext";

export interface RouteType {
  path?: string;
  name: string;
  icon?: string; 
  children?: RouteType[];
  requiredRoles?: string[];
  isLoading?: boolean;
  component?: React.ComponentType;
}

const useRoutes = (): RouteType[] => {
  const { t } = useLanguage();
  
  const routes: RouteType[] = [
    {
      path: "/dashboard",
      name: t('pages.dashboard.title'),
      icon: "bx bx-home-circle",
    },
    {
      path: "/mon-compte",
      name: t('pages.account.title'),
      icon: "bx bx-user",
    },
    {
      path: "/mon-magasin",
      name: t('pages.myStore.title'),
      icon: "bx bx-store",
    },
    {
      path: "/mes-offres",
      name: t('pages.offers.title'),
      icon: "bx bx-gift",
    },
  ];

  return routes;
};

export default useRoutes;